import { InjectionToken } from '@angular/core';

export interface EnvironmentConfig {
  deployment: string;
  jwtExchangeUrl?: string;
  proxyServer?: string;
  xsrfGetCall?: string;
  production?: boolean;
  internal?: boolean;
  appUrl?: string;
  vgnUrl?: string;
  LOGON_URL?: string;
}

export const ENVIRONMENT_CONFIG = new InjectionToken<EnvironmentConfig>('ENVIRONMENT_CONFIG');
